import React from 'react';
import Script from 'next/script';
import { useRouter } from 'next/router';
import { checkIsProduction } from '@/helpers/checkEnvironments';
const IS_PRODUCTION = checkIsProduction();
const TEST_HOUSES = [621, 29590, 30821, 31, 47806].map(id => `/houses/show/${id}`);
const Yektanet = () => {
  const router = useRouter();
  return IS_PRODUCTION && !TEST_HOUSES.includes(router.asPath || '') && <Script id="yektanet" strategy="beforeInteractive" defer>
        {`!(function (t, e, n) {
                (t.yektanetAnalyticsObject = n),
                (t[n] =
                    t[n] ||
                    function () {
                    t[n].q.push(arguments);
                    }),
                (t[n].q = t[n].q || []);
                var a = new Date(),
                r =
                    a.getFullYear().toString() +
                    "0" +
                    a.getMonth() +
                    "0" +
                    a.getDate() +
                    "0" +
                    a.getHours(),
                c = e.getElementsByTagName("script")[0],
                s = e.createElement("script");
                s.id = "ua-script-CZgLLz8O";
                s.dataset.analyticsobject = n;
                s.defer = !0;
                s.type = "text/javascript";
                (s.src =
                "https://cdn.yektanet.com/rg_woebegone/scripts_v3/CZgLLz8O/rg.complete.js?v=" +
                r),
                c.parentNode.insertBefore(s, c);
            })(window, document, "yektanet");`}
      </Script>;
};
export default Yektanet;